export const uploadImageAux = ({ setUserData, userData, onFileSelected }) => {
  const fileInput = document.createElement("input");
  fileInput.type = "file";
  fileInput.accept = "image/*";
  fileInput.style.display = "none";

  fileInput.onchange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.match("image.*")) {
      alert("Por favor, selecciona un archivo de imagen válido.");
      return;
    }

    // 1. Crear FormData con la imagen
    const formData = new FormData();
    formData.append("image", file); // "image" es el nombre del campo que Multer espera
    // console.log("Form data upload mage", formData);

    // 2. Crear URL de previsualización
    const previewUrl = URL.createObjectURL(file);

    setUserData({
      ...userData,
      urlImg: previewUrl,
      imageFile: file,
    });
  };

  document.body.appendChild(fileInput);
  fileInput.click();
  document.body.removeChild(fileInput);
};
